import Vue from 'vue'

// 防止重复提交指令
const preventReClick = Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (el.className.indexOf(" is-disabled") == -1) {
        el.className += " is-disabled"
        el.disabled = true
        setTimeout(() => {

          var reg = new RegExp(" is-disabled", "g");
          var str = el.className
          el.className = str.replace(reg, "");

          el.disabled = false
        }, binding.value || 3000)
      }
    })
  },
})

export default preventReClick


// WEBPACK FOOTER //
// ./src/components/common/prevent.js